export default __webpack_public_path__ + "hero-sm-6e94d823e5bbf0bdac9ea9fea3fcfa8e.digested.webp";